import FileType from "file-type/browser";
import ENV from "libs/configs/env";
import FileService from "services/FileService";

export const getPathFile = (path) => {
  const publicPath = ENV.getConfig().baseUrl + "\\Public\\" + path;
  const resolveWindowPath = publicPath.replace(/\\/g, "/");
  return resolveWindowPath;
};

export const getBlobFromUrl = (url) => {
  return new Promise((resolve, reject) => {
    let request = new XMLHttpRequest();
    request.open("GET", url, true);
    request.responseType = "blob";
    request.onload = () => {
      resolve(request.response);
    };
    request.onerror = reject;
    request.send();
  });
};

export const getDataFromBlob = (blob) => {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const getFileObjectURL = async (path) => {
  try {
    const blob = await getBlobFromUrl(path);
    return new File([blob], path);
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const openFileById = async (fileId) => {
  try {
    const blob = await FileService.getFile(fileId);
    const fileType = await FileType.fromBlob(blob);
    const fileFullName = `${fileId}.${fileType.ext}`;
    const blobFile = new File([blob], fileFullName, {
      type: fileType.mime,
    });

    window.open(URL.createObjectURL(blobFile), "_blank");
  } catch (error) {
    console.log("OpenFileById error: ", error);
  }
};
